import { FC } from 'react'

type Props = {
  percentage: number
  strokeWidth?: number
  circleColor?: string
  outerStrokeWidth?: number
}

const CircleBar: FC<Props> = ({
  percentage,
  strokeWidth = 20,
  circleColor = 'white',
  outerStrokeWidth = 4,
}) => {
  return (
    <svg
      viewBox="0 0 500 500"
      preserveAspectRatio="xMinYMin meet"
      style={{ transform: 'scaleX(-1)' }}
    >
      <path
        d="
        M 250, 250
        m -200, 0
        a 200, 200 0 1,0 400,0
        a 200, 200 0 1,0 -400,0"
        stroke={circleColor}
        strokeWidth={strokeWidth}
        strokeDasharray="1259"
        strokeDashoffset={`${1259 - 1259 * (percentage / 100)}`}
        fill="none"
      />
      {/* Inner */}
      <path
        d="
        M 250, 250
        m -190, 0
        a 190, 190 0 1,0 380,0
        a 190, 190 0 1,0 -380,0"
        stroke={circleColor}
        strokeWidth={outerStrokeWidth}
        fill="none"
      />
      {/* Outer */}
      <path
        d="
        M 250, 250
        m -210, 0
        a 210, 210 0 1,0 420,0
        a 210, 210 0 1,0 -420,0"
        stroke={circleColor}
        strokeWidth={outerStrokeWidth}
        fill="none"
      />
    </svg>
  )
}

export default CircleBar
